import { useLanguage } from "../i18n/LanguageContext";
import "./Hero.css";

export default function Hero() {
  const { t } = useLanguage();

  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <section id="hero" className="hero" aria-label="Introduction">
      <div className="hero-decoration hero-decoration-left" aria-hidden="true" />
      <div className="hero-decoration hero-decoration-right" aria-hidden="true" />
      <div className="hero-content">
        <h1 className="hero-title">{t.hero.title}</h1>
        <div className="hero-divider" aria-hidden="true">
          <span className="divider-dot" />
          <span className="divider-line" />
          <span className="divider-dot" />
        </div>
        <p className="hero-subtitle">{t.hero.subtitle}</p>
        <p className="hero-description">{t.hero.description}</p>
        <button className="hero-cta" onClick={() => scrollTo("courses")}>
          {t.hero.cta}
        </button>
      </div>
    </section>
  );
}
